import { createClient } from '@supabase/supabase-js'

const U = 'https://kuqspszbznvezfpvgvuk.supabase.co'
const K = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt1cXNwc3piem52ZXpmcHZndnVrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMxMTI3MTAsImV4cCI6MjA4ODY4ODcxMH0.J98VUCpLRTKkTDlMTCqF-0_98Cb-jpocBqB5F2-jI3Y'

export const supabaseClient = createClient(
  import.meta.env.VITE_SUPABASE_URL || U,
  import.meta.env.VITE_SUPABASE_ANON_KEY || K,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      storageKey: 'squids-auth',
      storage: window.localStorage
    },
    global: {
      headers: { 'x-client-info': 'squids-web' }
    },
    db: { schema: 'public' },
    realtime: { params: { eventsPerSecond: 10 } }
  }
)

export const createBrowserSupabaseClient = () => supabaseClient
export const supabase = { get client() { return supabaseClient } }
